import { render, staticRenderFns } from "./BankIntegrationAlert.vue?vue&type=template&id=ed33c9f4&scoped=true"
import script from "./BankIntegrationAlert.vue?vue&type=script&lang=js"
export * from "./BankIntegrationAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed33c9f4",
  null
  
)

export default component.exports